const api = {
        login: '/login',
        getOptOrCreate: '/otp/qrcode',
        bindOpt: '/otp/bind',
        logOut: '/logout'
}

export default api;